<template>
	<vx-card class="prazo-card-status prazo-card mb-6">
		<vs-collapse>
			<vs-collapse-item :open="true">
				<div slot="header" class="flex">
					<h3 class="flex items-center text-lg">Filtro por status</h3>
					<vs-chip color="primary" class="ml-2 font-semibold">{{ $store.state.fitrosCalendarioPrazos.status.length }}</vs-chip>
				</div>

				<VuePerfectScrollbar
					class="prazo-scroll-area"
					:settings="settingsPerfectScroll"
				>
					<vs-list>
						<label
							:for="'id-situacao-' + situacao.value"
							v-for="(situacao, index) in situacoes"
							:key="index"
							class="cursor-pointer"
						>
							<vs-list-item>
								<vs-checkbox
									:id="'id-situacao-' + situacao.value"
									v-model="
										$store.state.fitrosCalendarioPrazos
											.status
									"
									:vs-value="situacao.value"
								>
									{{ situacao.text }}
								</vs-checkbox>
							</vs-list-item>
						</label>
					</vs-list>
				</VuePerfectScrollbar>
			</vs-collapse-item>
		</vs-collapse>
	</vx-card>
</template>

<script>
import { Situacao } from "../../../../../models/Prazo";
export default {
	name: "CardStatus",
	data() {
		return {
			settingsPerfectScroll: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.2
			}
		};
	},
	computed: {
		situacoes() {
			return Situacao.listForSelect();
		}
	}
};
</script>

<style lang="scss" scoped src="./card_status.scss"></style>
